import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { map, takeUntil, startWith, switchMap } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import { Subject, of, EMPTY } from 'rxjs';
import * as i2 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class UserIdValidationLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    checkUserIdAvailability(userId) {
        // this.httpClient = this.httpClient.disableJwt();
        var usrId = this.toEncrypt(userId);
        return this.httpClient.post(`/validateUserId/${usrId}`, {}).pipe(map((response) => {
            return response;
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
UserIdValidationLibraryService.ɵfac = function UserIdValidationLibraryService_Factory(t) { return new (t || UserIdValidationLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
UserIdValidationLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: UserIdValidationLibraryService, factory: UserIdValidationLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserIdValidationLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function UserIdValidationLibraryComponent_li_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, " check_circle ");
    i0.ɵɵelementEnd();
} }
function UserIdValidationLibraryComponent_li_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, " cancel ");
    i0.ɵɵelementEnd();
} }
function UserIdValidationLibraryComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵtemplate(1, UserIdValidationLibraryComponent_li_2_span_1_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(2, UserIdValidationLibraryComponent_li_2_span_2_Template, 2, 0, "span", 4);
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4, " User Name / Id is available ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.userAvailable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.userAvailable);
} }
function UserIdValidationLibraryComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, " check_circle ");
    i0.ɵɵelementEnd();
} }
function UserIdValidationLibraryComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, " cancel ");
    i0.ɵɵelementEnd();
} }
function UserIdValidationLibraryComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, " check_circle ");
    i0.ɵɵelementEnd();
} }
function UserIdValidationLibraryComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, " cancel ");
    i0.ɵɵelementEnd();
} }
function UserIdValidationLibraryComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, " check_circle ");
    i0.ɵɵelementEnd();
} }
function UserIdValidationLibraryComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, " cancel ");
    i0.ɵɵelementEnd();
} }
function UserIdValidationLibraryComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, " check_circle ");
    i0.ɵɵelementEnd();
} }
function UserIdValidationLibraryComponent_span_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, " cancel ");
    i0.ɵɵelementEnd();
} }
class UserIdValidationLibraryComponent {
    constructor(userIdValidationLibraryService) {
        this.userIdValidationLibraryService = userIdValidationLibraryService;
        this.isValid = new EventEmitter();
        this.checkUserIdAvailability = false;
        this.isSystemGenerated = false;
        this.userAvailable = false;
        this.reset$ = new Subject();
        this.observableSubscription$ = new Subject();
        this.reset$.pipe(takeUntil(this.observableSubscription$), startWith(undefined), switchMap(() => {
            if (this.userId) {
                return this.isSystemGenerated ? of({ status: 200, data: { available: true } }) : this.userIdValidationLibraryService.checkUserIdAvailability(this.userId);
            }
            else {
                this.userAvailable = false;
                this.isValid.emit(false);
                return EMPTY;
            }
        }))
            .subscribe((response) => {
            if (response.status === 200 && response.data && response.data.available) {
                this.userAvailable = response.data.available;
                this.isValid.emit(response.data.available);
            }
            else {
                this.userAvailable = false;
                this.isValid.emit(false);
            }
        });
    }
    ngOnChanges(changes) {
        if (changes.userId) {
            this.userIdAvailable();
        }
    }
    userIdAvailable() {
        this.validateInput('totalCount');
        this.validateInput('aA1');
        this.validateInput('number');
        this.validateInput('specChar');
        if (this.checkUserIdAvailability && this.userIdValid) {
            this.reset$.next();
        }
    }
    validateInput(type) {
        let regex;
        if (type === 'totalCount') {
            regex = /^.{5,12}$/;
        }
        else if (type === 'aA1') {
            regex = /^(?=.*?[A-Za-z])/g;
        }
        else if (type === 'number') {
            regex = /^(?=.*\d)/g;
        }
        else if (type === 'specChar') {
            regex = /^[a-zA-Z0-9\\_\\-\\.]*$/;
        }
        if (this.userId.match(regex)) {
            this.isControlValid();
            return true;
        }
        else {
            this.userIdValid = false;
            this.isValid.emit(false);
            return false;
        }
    }
    isControlValid() {
        if (!this.userId || (this.userId && (this.userId.length < 5 || this.userId.length > 12))) {
            this.userIdValid = false;
            this.isValid.emit(false);
        }
        else {
            if (this.userId.match('.*[a-zA-Z]+.*')) {
                if (this.userId.match('.*[0-9]+.*')) {
                    const regex1 = '^[a-zA-Z0-9\\_\\-\\.]*$';
                    const regexResult = this.userId.match(regex1) ? true : false;
                    this.userIdValid = regexResult;
                    if (regexResult) {
                        if (!this.checkUserIdAvailability) {
                            this.isValid.emit(regexResult);
                        }
                    }
                    else {
                        this.isValid.emit(false);
                    }
                }
                else {
                    this.userIdValid = false;
                    this.isValid.emit(false);
                }
            }
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
UserIdValidationLibraryComponent.ɵfac = function UserIdValidationLibraryComponent_Factory(t) { return new (t || UserIdValidationLibraryComponent)(i0.ɵɵdirectiveInject(UserIdValidationLibraryService)); };
UserIdValidationLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: UserIdValidationLibraryComponent, selectors: [["lib-user-id-validation-library"]], inputs: { userId: "userId", checkUserIdAvailability: "checkUserIdAvailability", isSystemGenerated: "isSystemGenerated" }, outputs: { isValid: "isValid" }, features: [i0.ɵɵNgOnChangesFeature], decls: 25, vars: 9, consts: [[1, "validity-rule", "mb--20"], ["class", "flex-row", 4, "ngIf"], [1, "flex-row"], ["class", "material-icons valid-icon", 4, "ngIf"], ["class", "material-icons not-valid-icon", 4, "ngIf"], [1, "pl-1"], [1, "material-icons", "valid-icon"], [1, "material-icons", "not-valid-icon"]], template: function UserIdValidationLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "ul");
        i0.ɵɵtemplate(2, UserIdValidationLibraryComponent_li_2_Template, 5, 2, "li", 1);
        i0.ɵɵelementStart(3, "li", 2);
        i0.ɵɵtemplate(4, UserIdValidationLibraryComponent_span_4_Template, 2, 0, "span", 3);
        i0.ɵɵtemplate(5, UserIdValidationLibraryComponent_span_5_Template, 2, 0, "span", 4);
        i0.ɵɵelementStart(6, "span", 5);
        i0.ɵɵtext(7, " Must be within 5 to 12 characters ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "li", 2);
        i0.ɵɵtemplate(9, UserIdValidationLibraryComponent_span_9_Template, 2, 0, "span", 3);
        i0.ɵɵtemplate(10, UserIdValidationLibraryComponent_span_10_Template, 2, 0, "span", 4);
        i0.ɵɵelementStart(11, "span", 5);
        i0.ɵɵtext(12, " Must contain atleast 1 alphabet (A-Z, a-z) character(s) ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "li", 2);
        i0.ɵɵtemplate(14, UserIdValidationLibraryComponent_span_14_Template, 2, 0, "span", 3);
        i0.ɵɵtemplate(15, UserIdValidationLibraryComponent_span_15_Template, 2, 0, "span", 4);
        i0.ɵɵelementStart(16, "span", 5);
        i0.ɵɵtext(17, " Must contain atleast 1 number(0-9) characters(s) ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "li", 2);
        i0.ɵɵtemplate(19, UserIdValidationLibraryComponent_span_19_Template, 2, 0, "span", 3);
        i0.ɵɵtemplate(20, UserIdValidationLibraryComponent_span_20_Template, 2, 0, "span", 4);
        i0.ɵɵelementStart(21, "span", 5);
        i0.ɵɵtext(22, " May contain special character(s) ");
        i0.ɵɵelementStart(23, "small");
        i0.ɵɵtext(24, "(.-_)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.checkUserIdAvailability);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.validateInput("totalCount"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.validateInput("totalCount"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.validateInput("aA1"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.validateInput("aA1"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.validateInput("number"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.validateInput("number"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.validateInput("specChar"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.validateInput("specChar"));
    } }, directives: [i2.NgIf], styles: [".validity-rule[_ngcontent-%COMP%]{background-color:#f4f4f4;font-size:12px;width:auto;height:auto}.validity-rule[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:4px 2px}.validity-rule[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style:none;padding-top:3px}.validity-rule[_ngcontent-%COMP%]   .not-valid-icon[_ngcontent-%COMP%]{color:#ff5b5c;font-size:20px}.validity-rule[_ngcontent-%COMP%]   .valid-icon[_ngcontent-%COMP%]{color:green;font-size:20px}.validity-rule[_ngcontent-%COMP%]   .flex-row[_ngcontent-%COMP%]{display:flex;flex-direction:row}.mb--20[_ngcontent-%COMP%]{margin-bottom:-20px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserIdValidationLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-user-id-validation-library',
                templateUrl: './user-id-validation-library.component.html',
                styleUrls: ['./user-id-validation-library.component.scss']
            }]
    }], function () { return [{ type: UserIdValidationLibraryService }]; }, { userId: [{
            type: Input
        }], isValid: [{
            type: Output
        }], checkUserIdAvailability: [{
            type: Input
        }], isSystemGenerated: [{
            type: Input
        }] }); })();

class UserIdValidationLibraryModule {
}
UserIdValidationLibraryModule.ɵfac = function UserIdValidationLibraryModule_Factory(t) { return new (t || UserIdValidationLibraryModule)(); };
UserIdValidationLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: UserIdValidationLibraryModule });
UserIdValidationLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UserIdValidationLibraryModule, { declarations: [UserIdValidationLibraryComponent], imports: [PrimengLibraryModule], exports: [UserIdValidationLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserIdValidationLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UserIdValidationLibraryComponent
                ],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [
                    UserIdValidationLibraryComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of user-id-validation-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UserIdValidationLibraryComponent, UserIdValidationLibraryModule, UserIdValidationLibraryService };
//# sourceMappingURL=user-id-validation-library.js.map
